import React from 'react';
import { Link, useParams} from 'react-router-dom';

function BreadCrumb() {
  const {id, plantName} = useParams();
  // Convert slug (with -) back to spaces
  const decodedPlantName = plantName.replace(/-/g, ' ');
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">{decodedPlantName}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={`/cogendashboard/${plantName.replace(
                    /\s+/g,
                    "-"
                  )}/${id}`} className="breadcrumb-link">Cogeneration Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
            Cogeneration Plant Officials
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default BreadCrumb;
